import axios from 'axios';
import { getUserToken } from '../../utils/localStoarege';
import { hudAddPatintPackageInvoiceUrl, hudDoctoViewPatchUrl, hudPackageApiCRUDUrl, hudPackageApiOldCRUDUrl, hudPatientApiCRUDUrl } from '../../constants/apis/hud_apis';

export const getHudPatients = async (query) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudPatientApiCRUDUrl + query, config);
    return response;
};

export const getHudPatientsHistory = async (patintId) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudPatientApiCRUDUrl + patintId + "/history/", config);
    return response;
};

export const getHudPatientsPhotos = async (patintId) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudPatientApiCRUDUrl + patintId + "/photos/", config);
    return response;
};

export const postHudPatientsPhotos = async (patintId, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(hudPatientApiCRUDUrl + patintId + "/photos/", data, config);
    return response;
};

export const getHudPatientsPdfs = async (patintId) => {
    const token = getUserToken();
    const config = {
        headers: {
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudPatientApiCRUDUrl + patintId + "/pdfs/", config);
    return response;
};

export const postHudPatientsPdfs = async (patintId, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(hudPatientApiCRUDUrl + patintId + "/pdfs/", data, config);
    return response;
};

export const deleteHudPatientsPdfs = async (patintId, id) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.delete(hudPatientApiCRUDUrl + patintId + "/pdfs/" + id + "/", config);
    return response;
};

export const deleteHudPatientsPhoto = async (patintId, id) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.delete(hudPatientApiCRUDUrl + patintId + "/photos/" + id + "/", config);
    return response;
};

export const patchHudPatientsHistory = async (patintId, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(hudPatientApiCRUDUrl + patintId + "/history/", data, config);
    return response;
};

export const postPatient = async (data) => {
    const config = {
        headers: {
            Authorization: `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(hudPatientApiCRUDUrl, data, config);
    return response;
};

export const patchPatient = async (id, data) => {
    const config = {
        headers: {
            Authorization: `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(`${hudPatientApiCRUDUrl}${id}/`, data, config);
    return response;
};

export const getHudPatientsPackages = async (patintId) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudPatientApiCRUDUrl + patintId + "/packages/", config);
    return response;
};

export const addHudPatientPackageComment = async (packageId, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(hudPackageApiCRUDUrl + packageId + "/add-comment/", data, config);
    return response;
};

export const addHudPatientPackage = async (patientId, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(hudPatientApiCRUDUrl + patientId + "/add-package/", data, config);
    return response;
};

export const patchHudPatientPackage = async (patientId, packgeId, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(hudPatientApiCRUDUrl + patientId + "/update-package/" + packgeId + "/", data, config);
    return response;
};

export const updateHudPatientPackage = async (patientId, packageId, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(hudPatientApiCRUDUrl + patientId + "/update-package/" + packageId + "/", data, config);
    return response;
};

export const updateHudPatientDoctorView = async (patientId) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.patch(hudDoctoViewPatchUrl, { patient_id: patientId }, config);
    return response;
};

export const addHudPatientPackageInvoice = async (data) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.post(hudAddPatintPackageInvoiceUrl, data, config);
    return response;
};

export const patchHudPatientPackageApproval = async (id, data) => {
    const token = getUserToken();
    const config = {
        headers: {
            // "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };    
    const response = await axios.patch(hudPackageApiOldCRUDUrl + id + "/", data, config);
    return response;
};

export const getHudPatientsOintments = async (patintId) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudPatientApiCRUDUrl + patintId + "/ointments/", config);
    return response;
};

export const getHudPatientsTablets = async (patintId) => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudPatientApiCRUDUrl + patintId + "/tablets/", config);
    return response;
};

export const postMedicineChanges = async (data, patientId) => {
    const config = {
        headers: {
            Authorization: `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(hudPatientApiCRUDUrl + patientId + "/add-medicine/", data, config);
    return response;
};
